module.exports = __webpack_public_path__ + "06d699f7a3aaa6d413fc0922b8ea7ffb.png";